<template>
    <div>
        <template>
            <div class="bg-cover bg-no-repeat h-screen w-screen" style="background-image: url('https://6d65-mentor-3gyob3y3bdbc2bdb-1305613707.tcb.qcloud.la/static/sim_detail_bg.png')">
                <div class="pt-8 flex flex-col items-center">
                    <div class="h-60 w-160">
                        <img src="https://6d65-mentor-3gyob3y3bdbc2bdb-1305613707.tcb.qcloud.la/static/evaluation_login_text.png" class="w-full" alt="Login Text">
                    </div>
                    <div class="mt-8 text-24 text-center text-gray-700 -mt-10">
                        <div>您的测评数据将被严格加密存储</div>
                        <div>请放心填写</div>
                    </div>
                </div>

                <div class="px-6 flex  flex-col items-center" v-if="loginMode=='phone'">
                    <div class="w-full lg:w-3/5 mt-4 bg-white rounded-lg p-4 pb-6 pl-8  pr-8">
                        <div class="mb-8 flex flex-col gap-2  py-4">
                            <el-input v-model="realName"
                                      placeholder="请输入姓名"
                                      maxlength="10"
                                      class="no-border"></el-input>

                            <div class="flex items-center ">
                                <el-input v-model="phoneNumber"
                                          placeholder="请填写手机号"
                                            type="text"  class="flex-1"
                                            @input="phoneNumber = $event.replace(/[^\d]/g, '')"  >
                                    <template #append>
                                        <el-button v-if="countdown == 0" @click="visitorGetVerificationCode">获取验证码</el-button>
                                    </template>
                                </el-input>
                                <span v-if="countdown > 0" class="ml-2 ">{{ countdown }} 秒后可重新发送</span>
                            </div>

                            <!-- 验证码输入框 -->
                            <el-input v-model="verificationCode"
                                      placeholder="请输入验证码"
                                      class="no-border"></el-input>
                        </div>

                        <footer class="flex center items-center flex-1 flex-col gap-3">
                            <div class="flex flex-row items-center  justify-between">
                                <el-button type="primary" class="custom-button " @click="visitorLogin">登陆/注册</el-button>
                                <el-button type="info" class="custom-button" @click="loginMode='anonymous'">切换匿名登录</el-button>
                            </div>
                            <span class="text-xs text-center" @click="showPrivacy">
                                <span class="text-gray-500">登录即视为已阅读并同意</span>
                                <span class="font-bold text-blue-500">《用户服务协议及隐私政策》</span>
                            </span>
                        </footer>
                    </div>
                </div>
                <div class="px-6 flex  flex-col items-center" v-else>
                    <div class="w-full lg:w-3/5 mt-4 bg-white rounded-lg p-4 pb-6 pl-8  pr-8">
                        <div class="py-4 flex flex-col gap-2">
                            <el-input v-model="realName"
                                      placeholder="请输入昵称，确保咨询师可以认出你。"
                                      maxlength="10"
                                      class="no-border"></el-input>
                        </div>

                        <footer class="flex center items-center flex-1 flex-col gap-3">
                            <div>
                                <el-button type="primary" class="custom-button " @click="visitorLogin">匿名登录</el-button>
                                <el-button type="info" class="custom-button" @click="loginMode='phone'">手机登录</el-button>
                            </div>
                            <span class="text-xs text-center" @click="showPrivacy">
                                <span class="text-gray-500">登录即视为已阅读并同意</span>
                                <span class="font-bold text-blue-500">《用户服务协议及隐私政策》</span>
                            </span>
                        </footer>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import axios from 'axios';
    //import { jwtDecode } from 'jwt-decode';
    export default {
        computed: {
            isVisitorLoginVisible: {
                get() {
                    return this.value; // 读取父组件传入的值
                },
                set(val) {
                    this.$emit('input', val); // 触发 input 事件，更新父组件的值
                },
            },
        },
        methods: {
            //        te(token) { const decodedToken = jwtDecode(token); },
            async visitorGetVerificationCode() {
                if (!this.checkPhoneRule()) { return; }

                this.countdown = 60;
                this.countdownInterval = setInterval(() => {
                    if (this.countdown > 0) {
                        this.countdown--;
                    } else {
                        clearInterval(this.countdownInterval);
                    }
                }, 1000);

                try {
                    var data = {
                        phoneNumber: this.phoneNumber,
                    };
                    var jsonString = JSON.stringify(data);
                    const payload = { data: btoa(encodeURIComponent(jsonString)) };
                    const response = await axios.post('/api/questionnaire/get_verification_code', payload, {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    });
                    if (response.data.code != "00") {
                        this.$message.error('获取验证码失败:' + response.data.code + '_' + response.data.msg);
                    }
                } catch (error) {
                    this.$message.error('');
                    console.error('Failed to update token:', error);
                }
            },
            checkPhoneRule() {
                const phoneRegex = /^1[3-9]\d{9}$/;
                if (!phoneRegex.test(this.phoneNumber)) {
                    this.$message.error('请输入有效的手机号');
                    return false;
                }
                return true;
            },
            sendPreCheck() {
                var fieldsToValidate = [
                    { name: '姓名', value: this.realName },
                    { name: '手机号', value: this.phoneNumber },
                    { name: '验证码', value: this.verificationCode },
                ];
                if (this.loginMode != "phone") {
                    fieldsToValidate = [{ name: '昵称', value: this.realName },];
                }

                for (const field of fieldsToValidate) {
                    if (!field.value || field.value.trim() === '' || field.value.length < 1) {
                        this.$message.error(`请输入 ${field.name} ！`);
                        return false;
                    }
                }
                if (this.loginMode != "phone") {
                    return true;
                }
                return this.checkPhoneRule()
            },
            showPrivacy() {
                this.$message.info({ message: '正在打开...', duration: 1000 });
                axios.get('/api/protocol', { responseType: 'blob' })
                    .then(response => {
                        const url = URL.createObjectURL(response.data);
                        setTimeout(() => {
                            window.open(url, '_blank');
                        }, 1000);
                    })
                    .catch(error => {
                        console.error('获取 PDF 失败:', error);
                        this.$message.error(`获取失败！`);
                    });
            },
            randomString(length = 8) {
                const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                let result = '';
                for (let i = 0; i < length; i++) {
                    result += chars.charAt(Math.floor(Math.random() * chars.length));
                }
                return result;
            },
            async visitorLogin() {
                if (!this.sendPreCheck()) { return; }
                var data = {};
                
                if (this.loginMode != "phone") {//匿名方式
                    /*if (this.userid) {

                    }*/
                    data = {
                        loginType: this.loginMode,
                        loginInfo: this.realName,
                    }
                } else {//手机登录
                    data = {
                        loginType: this.loginMode,       
                        verificationCode: this.verificationCode,
                        phoneNumber: this.phoneNumber,
                        loginInfo: this.realName,
                    };
                }
                try {
                    var jsonString = JSON.stringify(data);
                    const payload = { data: btoa(encodeURIComponent(jsonString)) };
                    const response = await axios.post('/api/questionnaire/login', payload, {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    });
                    if (response.data.code == "00") {
                        localStorage.setItem('t-token', response.data.ttoken);
                        this.$emit('loginSuccess', { loginMode: this.loginMode, name: this.realName, phoneNumber: this.phoneNumber, verificationCode :this.verificationCode });
                    } else {
                        this.$message.error('Failed:' + response.data.code + '_' + response.data.msg);
                    }
                } catch (error) {
                    this.$message.error('');
                    console.error('Failed to update token:', error);
                }
            },
        },
        data() {
            return {
                userid: null,
                loginMode:"phone",
                realName: null,
                verificationCode: null,
                phoneNumber: null,
                countdownInterval: null,
                countdown: 0,
            };
        }
    };
</script>

<style>
    .iframe-style {
        border: none; /* 去掉边框 */
    }

    .custom-button {
        background-color: #006fff; /* 深蓝色 */
        padding-left: 24px;
    }

        .custom-button:hover {
        }
</style>